import './Theme.Navigation.Sidebar.scss';
export default 'ThemeNavigationSidebar';
